import { useEffect } from 'react';

import { useRouting } from '~/routing/useRouting';

import { trackPage } from '../SegmentAnalytics';

export const useTrackPage = () => {
  const { location } = useRouting();

  useEffect(() => {
    trackPage();
  }, [location]);
};
